import { CountryCode } from '../../i18n/countryCodes'
import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(lang: CountryCode) {
    const response = await api.fetch(`/api/v2/service/index/lang/${lang}`)
    return await handleResponse(response)
  }
}
